export default "/signup/_next/static/chunks/fonts/CircularStd-Book-c1441dbff704baa78817a36353ae5859.otf";